import React from 'react-redux';
import CellName from './Cells/CellName';
import CellAlgoStatus from './Cells/CellAlgoStatus';
import CellCheckbox from './Cells/CellCheckbox';
import CellEnabled from './Cells/CellEnabled';
import CellStatus from './Cells/CellStatus';
import CellBroker from './Cells/CellBroker';
import CellMtm from './Cells/CellMtm';
import CellAlerts from './Cells/CellAlerts';
import CellAction from './Cells/Action/CellAction';
import ClientIdHideButton from './Cells/ClientIdHideButton';
import MtmHideButton from './Cells/MtmHideButton';
import AlertCount from './Cells/AlertCount';
import CellMultiplier from './Cells/CellMultiplier';
import CellStartTime from './Cells/CellStartTime';
import CellTradeType from './Cells/CellTradeType';
import CellTransactionType from './Cells/CellTransactionType';
import CellUnderlyingSymbols from './Cells/CellUnderlyingSymbols';
import CellAlgoId from './Cells/CellAlgoId';
import CellEndTime from './Cells/CellEndTime';
import ViewEnabled from './Cells/View/ViewEnabled';
import ViewStatus from './Cells/View/ViewStatus';
import ViewStartTime from './Cells/View/ViewStartTime';
import ViewTradeType from './Cells/View/ViewTradeType';
import ViewUnderlying from './Cells/View/ViewUnderlyingSymbols';
import ViewTransactionType from './Cells/View/ViewTransactionType';
import ViewAlgoStatus from './Cells/View/ViewAlgoStatus';
import ViewAlerts from './Cells/View/ViewAlerts';
import ViewBroker from './Cells/View/ViewBroker';
import ViewMultiplier from './Cells/View/ViewMultiplier';
import ViewEndTime from './Cells/View/ViewEndTime';
import HeadCellAlerts from './Headers/HeadCellAlerts';
import CellEntryErrors from './Cells/CellEntryErrors';
import CellExitErrors from './Cells/CellExitErrors';
import HeadCellShrink from '../../../components/AdvancedListTable/HeadCellShrink';
import ViewEntryErrors from './Cells/View/ViewEntryErrors';
import ViewExitErrors from './Cells/View/ViewExitErrors';
import ViewActive from './Cells/View/ViewActive';

export const columns = [
  {
    Header: () => <></>,
    width: 60,
    minWidth: 60,
    accessor: 'selectAlgo',
    Cell: ({ row = {} }) => <CellCheckbox row={row} />,
    HeaderExtended: () => <ViewActive />,
    innerDivProps: {
      innerDivStyle: {
        justifyContent: 'center',
        paddingLeft: 0,
        alignItems: 'center',
      },
    },
  },
  {
    Header: 'Enable',
    width: 100,
    minWidth: 100,
    accessor: 'enabled',
    Cell: ({ row = {} }) => <CellEnabled row={row} />,
    innerDivProps: {
      innerDivStyle: { justifyContent: 'center' },
    },
    HeaderExtended: () => <ViewEnabled />,
  },
  {
    Header: 'Status',
    accessor: 'status',
    width: 130,
    minWidth: 130,
    Cell: ({ row = {} }) => <CellStatus row={row} />,
    cellProps: {
      align: 'center',
    },
    innerDivProps: {
      dataKey: 'status',
      isSortable: true,
      innerDivStyle: { justifyContent: 'center' },
    },
    HeaderExtended: () => <ViewStatus />,
  },
  {
    Header: 'Client ID / Broker',
    accessor: 'broker',
    width: 250,
    minWidth: 250,
    Cell: ({ row = {} }) => <CellBroker row={row} />,
    innerDivProps: {
      innerDivStyle: { justifyContent: 'center' },
      dataKey: 'broker',
      isSortable: true,
    },
    HeaderExtended: () => (
      <>
        <ClientIdHideButton />
        <ViewBroker />
      </>
    ),
  },
  {
    Header: 'Multiplier',
    accessor: 'multiplier',
    width: 140,
    minWidth: 140,
    Cell: ({ row = {} }) => <CellMultiplier row={row} />,
    innerDivProps: {
      innerDivStyle: { justifyContent: 'center' },
      dataKey: 'multiplier',
      isSortable: true,
    },
    HeaderExtended: () => <ViewMultiplier />,
  },
  {
    Header: 'MTM',
    accessor: 'pnl',
    width: 120,
    minWidth: 120,
    Cell: ({ row = {} }) => <CellMtm row={row} />,
    innerDivProps: {
      dataKey: 'pnl',
      isSortable: true,
    },
    HeaderExtended: () => <MtmHideButton />,
  },
  {
    Header: () => <HeadCellAlerts />,
    accessor: 'alerts',
    width: 120,
    minWidth: 100,
    Cell: ({ row = {} }) => <CellAlerts row={row} />,
    innerDivProps: {
      innerDivStyle: { justifyContent: 'center' },
      dataKey: 'alerts',
      isSortable: true,
      SortComponent: () => <AlertCount />,
    },
    HeaderExtended: () => <ViewAlerts />,
  },
  {
    Header: '',
    accessor: 'algo-status',
    width: 70,
    minWidth: 70,
    Cell: ({ row = {} }) => <CellAlgoStatus row={row} />,
    innerDivProps: {
      dataKey: 'algo-status',
      isSortable: true,
      innerDivStyle: { justifyContent: 'center' },
    },
    HeaderExtended: () => <ViewAlgoStatus />,
  },
  {
    Header: 'Algo name',
    accessor: 'name',
    width: 325,
    minWidth: 225,
    Cell: ({ row = {} }) => <CellName row={row} />,
    innerDivProps: {
      dataKey: 'name',
      isSortable: true,
    },
  },
  {
    Header: 'Actions',
    accessor: 'actions',
    width: 164,
    minWidth: 164,
    Cell: ({ row = {} }) => <CellAction row={row} />,
    innerDivProps: {
      innerDivStyle: { justifyContent: 'center' },
    },
  },
  {
    Header: <HeadCellShrink>Entry Errors</HeadCellShrink>,
    HeaderSimple: 'Entry Errors',
    accessor: 'entryErrorCount',
    width: 152,
    minWidth: 40,
    innerDivProps: {
      innerDivStyle: { justifyContent: 'center' },
      dataKey: 'entryErrorCount',
      isSortable: true,
    },
    meta: {
      toggle: true,
      toggleDefaultState: true,
    },
    Cell: ({ row = {} }) => <CellEntryErrors row={row} />,
    HeaderExtended: () => <ViewEntryErrors />,
  },
  {
    Header: <HeadCellShrink>Exit Errors</HeadCellShrink>,
    HeaderSimple: 'Exit Errors',
    accessor: 'exitErrorCount',
    width: 152,
    minWidth: 40,
    innerDivProps: {
      innerDivStyle: { justifyContent: 'center' },
      dataKey: 'exitErrorCount',
      isSortable: true,
    },
    meta: {
      toggle: true,
      toggleDefaultState: true,
    },
    Cell: ({ row = {} }) => <CellExitErrors row={row} />,
    HeaderExtended: () => <ViewExitErrors />,
  },
  {
    Header: 'Start Time',
    accessor: 'startTime',
    width: 152,
    minWidth: 152,
    Cell: ({ row = {} }) => <CellStartTime row={row} />,
    innerDivProps: {
      dataKey: 'startTime',
      isSortable: true,
      innerDivStyle: { justifyContent: 'center' },
    },
    meta: {
      toggle: true,
      toggleDefaultState: true,
    },
    HeaderExtended: () => <ViewStartTime />,
  },
  {
    Header: 'End Time',
    accessor: 'endTime',
    width: 150,
    minWidth: 150,
    Cell: ({ row = {} }) => <CellEndTime row={row} />,
    innerDivProps: {
      dataKey: 'endTime',
      isSortable: true,
      innerDivStyle: { justifyContent: 'center' },
    },
    meta: {
      toggle: true,
      toggleDefaultState: true,
    },
    HeaderExtended: () => <ViewEndTime />,
  },
  {
    Header: 'Trade type',
    accessor: 'tradingType',
    width: 170,
    minWidth: 170,
    Cell: ({ row = {} }) => <CellTradeType row={row} />,
    innerDivProps: {
      dataKey: 'tradingType',
      isSortable: true,
      innerDivStyle: { justifyContent: 'center' },
    },
    meta: {
      toggle: true,
      toggleDefaultState: true,
    },
    HeaderExtended: () => <ViewTradeType />,
  },
  {
    Header: 'Underlying',
    accessor: 'underlyingSymbols',
    width: 160,
    minWidth: 160,
    Cell: ({ row = {} }) => <CellUnderlyingSymbols row={row} />,
    innerDivProps: {
      dataKey: 'underlyingSymbols',
      isSortable: true,
    },
    meta: {
      toggle: true,
      toggleDefaultState: true,
    },
    HeaderExtended: () => <ViewUnderlying />,
  },
  {
    Header: 'Buy/Sell',
    accessor: 'transactionType',
    width: 140,
    minWidth: 140,
    Cell: ({ row = {} }) => <CellTransactionType row={row} />,
    innerDivProps: {
      dataKey: 'transactionType',
      isSortable: true,
      innerDivStyle: { justifyContent: 'center' },
    },
    meta: {
      toggle: true,
      toggleDefaultState: true,
    },
    HeaderExtended: () => <ViewTransactionType />,
  },
  {
    Header: 'Algo ID',
    accessor: '_id',
    width: 210,
    minWidth: 128,
    Cell: ({ row = {} }) => <CellAlgoId row={row} />,
    meta: {
      toggle: true,
      toggleDefaultState: false,
    },
  },
];
